import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { useIsFetching } from '@tanstack/react-query';
import { ToastProvider } from '../components/ui/Toast.js';
import { ErrorBoundary } from '../components/ui/ErrorBoundary.js';

export const Route = createRootRoute({
  component: Root,
});

/** Thin 2px progress bar shown whenever any TanStack Query is in-flight */
function GlobalProgressBar() {
  const isFetching = useIsFetching();
  if (!isFetching) return null;
  return (
    <div className="progress-bar-track" aria-hidden="true">
      <div className="progress-bar-fill" />
    </div>
  );
}

/** Wraps page content so each route change fades in at 150ms */
function PageWrapper() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <div key={pathname} className="animate-page-in">
      <Outlet />
    </div>
  );
}

function Root() {
  return (
    <ToastProvider>
      <GlobalProgressBar />
      <ErrorBoundary>
        <PageWrapper />
      </ErrorBoundary>
    </ToastProvider>
  );
}
